{
  "names": {
    "Fajr": "الفجر",
    "Dhuhr": "الظهر",
    "Asr": "العصر",
    "Maghrib": "المغرب",
    "Isha": "العشاء"
  },
  "card": {
    "label": "الصلاة القادمة",
    "labelTomorrow": "غدًا · {{prayer}}",
    "inHoursMinutes": "خلال {{hours}} س {{minutes}} د",
    "inMinutes": "خلال {{minutes}} د",
    "open_aria": "فتح أوقات الصلاة",
    "pro": "Rhemn Pro",
    "unlock_aria": "افتح أوقات الصلاة مع Rhemn Pro",
    "unavailable": "أوقات الصلاة غير متاحة حاليًا."
  },
  "sheet": {
    "bellOn_aria": "إيقاف تذكير {{prayer}}",
    "bellOff_aria": "تشغيل تذكير {{prayer}}",
    "explainer": "احصل على تذكير لطيف عند كل صلاة. التذكيرات إشعارات صامتة — بلا صوت افتراضيًا.",
    "enableReminders": "تفعيل التذكيرات",
    "enableInSettings": "فعّل إشعارات Rhemn من الإعدادات لتصلك تذكيرات الصلاة.",
    "openSettings": "افتح الإعدادات"
  },
  "notifications": {
    "body": "حان وقت الصلاة."
  },
  "focus": {
    "label": "صلاة {{prayer}}",
    "close_aria": "إغلاق شاشة الصلاة",
    "hint": "اضغط Esc أو × للعودة",
    "phrases": {
      "accepted": "تقبّل الله صلاتك",
      "acceptedAr": "تقبّل الله صلاتك"
    }
  },
  "ambient": {
    "default": "ابدأ بالنيّة. واستمر بالبركة.",
    "prayerApproaches": "اقترب موعد صلاتك القادمة. ابقَ راسخًا في نيّتك.",
    "morningPursue": "صباح مبارك لتسعى نحو: {{focus}}",
    "dayCloses": "مع انقضاء اليوم، تأمّل في: {{focus}}",
    "fulfilled": "حقّقت نيّتك اليوم. الحمد لله.",
    "workingTowards": "تسعى اليوم نحو: {{focus}}",
    "prayerNear": "اقتربت صلاتك القادمة. خذ نفسًا."
  },
  "widget": {
    "countdown": "خلال {{time}}",
    "openToUpdate": "افتح Rhemn للتحديث",
    "openForVerse": "افتح Rhemn لآية اليوم"
  }
}
